import {Component} from "react"


class ExplanationText extends Component<any> {
    render() {
        return (
            <div className="explanation-text"> 
                <p>Ireland's instant house valuation tool </p>
                <p>Enter your address and hit search</p>
            </div>
        )
    }
}

export default ExplanationText
